import * as XLSX from 'xlsx';

/**
 * Export an array of row objects as a single-sheet xlsx download.
 *
 * Pattern mirrors the only prior consumer in the codebase:
 *   InvoiceReportPage.js:111-114.
 * Callers own the row shape (each key becomes a column header).
 *
 * @param {Array<object>} rows      flat objects; keys are column headers
 * @param {string}        sheetName sheet tab name
 * @param {string}        filename  final .xlsx filename (extension included)
 */
export function exportToExcel(rows, sheetName, filename) {
  const ws = XLSX.utils.json_to_sheet(rows || []);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, filename);
}
